export default __webpack_public_path__ + "static/au_cells-7320297fabd6305aae6758fa4997b843.jpg";